import { MARKETING_MATERIAL_TYPE } from '../../../../views/AlbumFolder/AlbumFolderMarketing/constants';

/**
 * Returns which marketing material types allow for configuration
 *
 * @param {String} marketingMaterialType Marketing Material type to confirm.
 * @returns {boolean} Whether configuration is required or not.
 */
export const marketingMaterialRequiresConfiguration = marketingMaterialType => {
  return [MARKETING_MATERIAL_TYPE.EVENT_FLYER].includes(marketingMaterialType);
};
